import React, { Component } from 'react'
import { DropTarget, DragSource } from 'react-dnd'
import ItemTypes from '~/utils/TemplateEditor/dragDropItemTypes'
import { findDOMNode } from 'react-dom'
import Icon from '~/Common-Objects/UI/Icon'
import cloneDeep from 'lodash/cloneDeep'

const dragSource = {
    beginDrag(props) {
        // Hand over a private copy so we never mutate the shared palette object during hover/insert
        return { path: '', isNew: 0, content: cloneDeep(props.content) }
    },
    endDrag(props, monitor) {}
}

@DragSource(ItemTypes.NEWHOLDER, dragSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
}))
export default class NewHolderObject extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { canDrop, isOver, connectDragSource, isDragging } = this.props
        return connectDragSource(
            <div
                className='newElementObject-layoutEdition'
                id={this.props.id}
                alt={this.props.title}
                title={this.props.title}
            >
                {this.props.icon ? (
                    <Icon name={this.props.icon} className='newElementObject-icon' />
                ) : (
                    <img src={this.props.toolbarIcon} className='newElementObject-icon' />
                )}
            </div>
        )
    }
}
